/**
 * Arabic Dashboard Content - UI strings for Arabic dashboard at /ar/dashboard
 * This file contains all translatable strings for the dashboard interface.
 */
window.ArabicDashboardContent = {
    // ==========================================
    // HEADER & NAVIGATION
    // ==========================================
    header: {
        dashboard: "لوحة التحكم",
        responses: "الردود",
        myForms: "نماذجي",
        signOut: "تسجيل الخروج",
        upgrade: "ترقية",
        free: "مجاني",
        basic: "ايفنت برو",
        premium: "Signature",
        viewOnly: "عرض فقط"
    },

    // ==========================================
    // TAB NAVIGATION
    // ==========================================
    tabs: {
        responses: "الردود",
        analytics: "الإحصائيات",
        campaigns: "رسائل الضيوف",
        export: "تصدير"
    },

    // ==========================================
    // RESPONSES TAB
    // ==========================================
    responses: {
        title: "الردود",
        totalResponses: "إجمالي الردود",
        attending: "حاضرون",
        notAttending: "غير حاضرين",
        maybe: "ربما",
        adults: "بالغين",
        children: "أطفال",
        searchPlaceholder: "بحث بالاسم، البريد أو الهاتف...",
        filterAll: "كل الردود",
        filterYes: "نعم - حاضرون",
        filterNo: "لا - غير حاضرين",
        filterMaybe: "ربما",
        noResponses: "لا توجد ردود بعد",
        noResponsesDesc: "ستظهر الردود هنا عندما يؤكد الضيوف الحضور.",
        shareFirstDesc: "شارك الرابط مع ضيوفك، وستظهر ردودهم هنا.",
        sendInvitations: "إرسال الدعوات",
        copyLink: "نسخ الرابط",
        generalLink: "الرابط العام",
        personalLinks: "الروابط الشخصية",
        loading: "جاري تحميل الردود...",
        deleteConfirm: "هل أنت متأكد أنك تريد حذف هذا الرد؟",
        deleteSuccess: "تم حذف الرد بنجاح",
        saveSuccess: "تم حفظ التغييرات بنجاح",
        saveError: "خطأ في حفظ التغييرات"
    },

    // ==========================================
    // TABLE HEADERS
    // ==========================================
    table: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        attending: "الحضور",
        guestCount: "الضيوف",
        dietary: "النظام الغذائي",
        relationship: "العلاقة",
        message: "الرسالة",
        submittedAt: "تاريخ التقديم",
        actions: "إجراءات",
        yes: "نعم",
        no: "لا",
        maybe: "ربما"
    },

    // ==========================================
    // ANALYTICS TAB
    // ==========================================
    analytics: {
        title: "إحصائيات الحدث",
        responseRate: "معدل الاستجابة",
        totalInvited: "إجمالي المدعوين",
        totalResponded: "إجمالي المستجيبين",
        pending: "قيد الانتظار",
        attendanceBreakdown: "توزيع الحضور",
        guestBreakdown: "توزيع الضيوف",
        responseTimeline: "الجدول الزمني للردود",
        dietaryPreferences: "تفضيلات غذائية",
        relationships: "العلاقات",
        setupTracking: "إعداد التتبع",
        setupTrackingDesc: "أدخل عدد الدعوات المرسلة لرؤية إحصائيات معدل الاستجابة.",
        invitationsSent: "الدعوات المرسلة",
        manualCount: "عد يدوي",
        autoDetection: "كشف تلقائي",
        switchToAuto: "التبديل للكشف التلقائي؟",
        noAnalyticsYet: "لا توجد إحصائيات متاحة بعد",
        noAnalyticsDesc: "ستظهر الإحصائيات عند تلقي الردود."
    },

    // ==========================================
    // GUEST MESSAGES TAB
    // ==========================================
    messages: {
        title: "رسائل الضيوف",
        newMessage: "رسالة جديدة",
        sendInvitations: "إرسال دعوات",
        messageHistory: "سجل الرسائل",
        noMessages: "جاهز لدعوة ضيوفك؟",
        noMessagesDesc: "أرسل رسائل مخصصة عبر البريد أو واتساب. سنقوم بتتبع من فتح وأجاب.",
        createFirst: "إرسال رسائل",
        contactStatus: "حالة جهات الاتصال",
        sendReminder: "إرسال تذكير",
        scheduledReminders: "تذكيرات مجدولة",
        credits: "رصيد",
        buyCredits: "شراء رصيد",
        messagesSent: "رسائل أرسلت",
        delivered: "تم التسليم",
        opened: "تم الفتح",
        clicked: "تم النقر",
        responded: "تم الرد",
        pending: "قيد الانتظار"
    },

    // ==========================================
    // CAMPAIGN WIZARD
    // ==========================================
    wizard: {
        title: "إرسال دعوات",
        step1: "جهات الاتصال",
        step2: "مراجعة",
        step3: "إرسال",
        addContacts: "إضافة جهات اتصال",
        importFromFile: "استيراد من ملف",
        pasteContacts: "لصق جهات اتصال",
        manualEntry: "إدخال يدوي",
        uploadCSV: "رفع CSV",
        uploadVCard: "رفع vCard",
        dragDropHere: "اسحب الملفات هنا أو انقر للبحث",
        supportedFormats: "الصيغ المدعومة: CSV, VCF (vCard)",
        contactsAdded: "جهات اتصال أضيفت",
        reviewContacts: "مراجعة جهات الاتصال",
        removeSelected: "إزالة المحدد",
        selectAll: "تحديد الكل",
        deselectAll: "إلغاء تحديد الكل",
        messageTemplate: "قالب الرسالة",
        personalizeMessage: "تخصيص الرسالة",
        previewMessage: "معاينة الرسالة",
        sendVia: "إرسال عبر",
        email: "البريد الإلكتروني",
        whatsapp: "واتساب",
        both: "كلاهما",
        schedule: "جدولة",
        sendNow: "إرسال الآن",
        scheduleLater: "جدولة لاحقاً",
        confirmSend: "تأكيد الإرسال",
        sending: "جاري الإرسال...",
        sent: "تم الإرسال",
        failed: "فشل",
        cancel: "إلغاء",
        back: "رجوع",
        next: "التالي",
        finish: "إنهاء"
    },

    // ==========================================
    // EXPORT TAB
    // ==========================================
    export: {
        title: "تصدير البيانات",
        exportCSV: "تصدير لـ CSV",
        exportLanguage: "لغة التصدير",
        original: "أصلي (بدون ترجمة)",
        selectLanguage: "اختر لغة...",
        exportAll: "تصدير الكل",
        exportFiltered: "تصدير المصفي",
        downloading: "جاري التحميل...",
        downloadComplete: "اكتمل التحميل",
        noDataToExport: "لا توجد بيانات للتصدير"
    },

    // ==========================================
    // MODALS
    // ==========================================
    modals: {
        editResponse: "تعديل الرد",
        deleteResponse: "حذف الضيف",
        confirmDelete: "هل أنت متأكد أنك تريد حذف هذا الرد؟ لا يمكن التراجع عن هذا الإجراء.",
        sendReminder: "إرسال تذكير ذكي",
        reminderDesc: "يتم تصفية المستلمين بناءً على تتبع الرسائل.",
        recipients: "المستلمين",
        customMessage: "رسالة مخصصة (اختياري)",
        customMessagePlaceholder: "أضف ملاحظة شخصية...",
        scheduledReminders: "إعداد تذكيرات مجدولة",
        enableReminders: "تفعيل التذكيرات المجدولة",
        reminderTiming: "متى يتم إرسال التذكيرات:",
        oneDay: "يوم قبل",
        threeDays: "3 أيام قبل",
        oneWeek: "أسبوع قبل",
        twoWeeks: "أسبوعين قبل",
        contactStatus: "حالة جهات الاتصال",
        allContacts: "كل جهات الاتصال",
        respondedFilter: "تم الرد",
        pendingFilter: "رد معلق",
        doubleResponse: "رد مزدوج ⚠️",
        emailStatus: "حالة البريد",
        whatsappStatus: "حالة واتساب",
        translating: "جاري ترجمة الردود",
        translatingTo: "ترجمة الردود إلى"
    },

    // ==========================================
    // USER EVENTS
    // ==========================================
    events: {
        myEvents: "مناسباتي",
        noEvents: "لم يتم العثور على مناسبات",
        noEventsDesc: "لم تقم بإنشاء أي نموذج RSVP بعد.",
        createFirst: "أنشئ مناسبتك الأولى",
        created: "أنشئت",
        eventId: "معرف الحدث",
        viewResponses: "عرض الردود",
        loadingEvents: "جاري تحميل مناسباتك...",
        errorLoading: "خطأ في تحميل المناسبات"
    },

    // ==========================================
    // AUTH
    // ==========================================
    auth: {
        signIn: "تسجيل الدخول",
        signInDesc: "سجل الدخول لرؤية نماذجك",
        signInPrompt: "سجل الدخول للوصول",
        loginWithEmail: "دخول بالبريد الإلكتروني",
        loginWithGoogle: "المتابعة مع جوجل",
        loginWithApple: "المتابعة مع أبل",
        or: "أو",
        noAccount: "لا تملك حساب؟",
        createAccount: "إنشاء حساب"
    },

    // ==========================================
    // COMMON
    // ==========================================
    common: {
        loading: "جاري التحميل...",
        save: "حفظ",
        cancel: "إلغاء",
        close: "إغلاق",
        delete: "حذف",
        edit: "تعديل",
        confirm: "تأكيد",
        send: "إرسال",
        search: "بحث",
        filter: "تصفية",
        refresh: "تحديث",
        backToEvents: "العودة لمناسباتي",
        backToAccess: "العودة لخيارات الوصول",
        selectEvent: "اختر مناسبة",
        selectEventDesc: "يرجى اختيار مناسبة محددة من القائمة أعلاه.",
        error: "خطأ",
        success: "نجاح",
        warning: "تحذير",
        info: "معلومات",
        guests: "ضيوف"
    },

    // ==========================================
    // UPGRADE PROMPTS
    // ==========================================
    upgrade: {
        unlockResponses: "فتح كل الردود",
        freeLimit: "يمكنك رؤية حتى 25 رد.",
        upgradeForUnlimited: "رقِ لعرض غير محدود →",
        upgradeRequired: "ترقية مطلوبة"
    },

    // ==========================================
    // ANALYTICS INSIGHTS (Dynamic JS Content)
    // ==========================================
    insights: {
        // Pattern Insights
        peakResponseDay: "يوم ذروة الردود",
        peakResponseTime: "وقت ذروة الردود",
        responseMomentum: "زخم الردود",
        attendanceRate: "معدل الحضور",
        daysUntilEvent: "أيام حتى الحدث",
        eventDay: "يوم الحدث",

        // Velocity labels
        pickingUp: "يتزايد",
        slowingDown: "يتباطأ",
        steadyPace: "وتيرة ثابتة",
        responsesComing: "الردود تأتي بشكل أسرع مؤخراً",
        responseDecreased: "انخفض معدل الردود",
        consistentRate: "معدل ردود ثابت",

        // Smart Insights
        excellentResponseRate: "معدل استجابة ممتاز",
        lowResponseRate: "معدل استجابة منخفض",
        highGuestMultiplier: "مضاعف ضيوف مرتفع",
        lowerGuestImpact: "تأثير ضيوف أقل",
        attendanceConcerns: "مخاوف الحضور",
        strongAttendance: "التزام حضور قوي",

        // Insight descriptions
        respondedWellAbove: "من الضيوف ردوا - أعلى بكثير من المتوسط!",
        onlyResponded: "فقط ردوا. فكر في إرسال تذكيرات.",
        guestImpact: "تأثير الضيوف - الناس يحضرون مرافقين!",
        ensureVenue: "تأكد من أن المكان والضيافة يستوعبون العدد الأكبر.",
        fewerPlusOnes: "تأثير الضيوف يشير لمرافقين أقل من المتوقع.",
        encourageCompanions: "فكر في تشجيع الضيوف على إحضار مرافقين.",
        respondentsAttending: "من المستجيبين سيحضرون.",
        investigateBarriers: "تحقق من تعارضات محتملة أو مشاكل في التاريخ/المكان.",
        showsStrongInterest: "معدل الحضور يظهر اهتماماً قوياً بحدثك!",

        // Activity insights
        greatMomentum: "زخم رائع!",
        activeResponses: "ردود نشطة",
        recentActivity: "نشاط حديث",
        responsesThisWeek: "ردود هذا الأسبوع بوتيرة متسارعة",
        responsesLast7Days: "ردود في آخر 7 أيام - تفاعل جيد",
        responseInLast: "رد(ود) في آخر 7 أيام",

        // Prediction
        expectedFinalAttendance: "الحضور النهائي المتوقع",
        projecting: "توقعات بـ",
        totalGuests: "إجمالي الضيوف بناءً على الاتجاهات الحالية",
        highConfidence: "ثقة عالية",
        moderateConfidence: "ثقة متوسطة",
        earlyEstimate: "تقدير مبكر",
        getMoreResponses: "احصل على المزيد من الردود لتحسين الدقة",

        // Event countdown
        finalCountdown: "العد التنازلي النهائي!",
        comingSoon: "قريباً",
        timeToPrepare: "وقت التحضير",
        daysRemaining: "يوم(ايام) متبقية",
        eventIsToday: "مناسبتك اليوم!",

        // Additional insights
        highResponseVelocity: "سرعة استجابة عالية",
        responsesLast24h: "ردود في آخر 24 ساعة تشير لتفاعل قوي",
        optimalCommunicationDay: "يوم التواصل الأمثل",
        showsResponses: "يظهر",
        ofResponses: "من الردود - مثالي للمتابعة",
        scheduleRemindersOn: "جدول تذكيرات مستقبلية لأقصى معدل ردود",
        slowResponseCollection: "جمع ردود بطيء",
        averagingResponses: "بمتوسط",
        responsesPerDay: "ردود يومياً في",
        days: "أيام",
        considerDeadline: "فكر في رسائل عاجلة أو حوافز لتسريع الردود",
        timeForFollowUp: "وقت المتابعة",
        noResponsesIn: "لا ردود في",
        reminderCouldBoost: "أيام - تذكير قد يعزز التفاعل",

        // Engagement insights
        highDetailEngagement: "تفاعل عالي بالتفاصيل",
        providedDietary: "وفروا معلومات غذائية - ضيوف متفاعلون جداً",
        groupEventPattern: "نمط حدث جماعي",
        bringingPeople: "الضيوف يحضرون",
        peopleOnAverage: "أشخاص في المتوسط - خطط لمجموعات",
        ensureSeating: "أمن مقاعد وضيافة لمجموعات",
        lowFieldCompletion: "إكمال حقول منخفض",
        hasLowCompletion: "لديه إكمال منخفض",
        haveLowCompletion: "لديهم إكمال منخفض",
        considerRequired: "فكر في جعل الحقول الرئيسية إلزامية",

        // Final week
        finalWeekPush: "دفعة الأسبوع الأخير مطلوبة",
        eventIn: "المناسبة في",
        daysWithOnly: "أيام مع فقط",
        responseRateLabel: "معدل الاستجابة",
        attendanceRateLabel: "معدل الحضور",
        sendUrgentReminder: "أرسل تذكير عاجل أخير لتعظيم التأكيدات",
        finalPlanningWindow: "نافذة التخطيط النهائية",
        daysLeft: "أيام متبقية - وقت العد النهائي واللوجستيات",
        finalizeCatering: "أكد كميات الضيافة وارسل التفاصيل للمؤكدين",

        // Chart Labels
        adults: "بالغين",
        children: "أطفال",
        guests: "ضيوف",
        dietary: "متطلبات غذائية",
        relationship: "علاقة",
        attending: "حاضرون",
        maybe: "ربما",
        notAttending: "غير حاضرين",
        noResponse: "لا رد",

        // Activity
        someone: "شخص ما",
        confirmedAttendance: "أكد الحضور",
        declined: "رفض",
        fromBulk: "من الرسائل",
        manual: "يدوي",
        fromBulkMessaging: "من الرسائل الجماعية",
        clickToAdjust: "انقر للتعديل",
        sendBulkToUnlock: "أرسل رسائل لفتح هذا المقياس",
        guestsConfirmed: "ضيوف مؤكدون من",
        invitations: "دعوات",
        day: "يوم",
        untilEvent: "حتى الحدث",

        // Saturation
        responseSaturation: "تم الوصول لتشبع الردود",
        patternSuggests: "النمط يشير أنك حصلت على معظم الردود المتاحة",

        // Live Activity
        liveUpdates: "تحديثات حية",
        live: "مباشر",
        reached: "تم الوصول لـ",
        responses: "ردود!",
        latest: "مؤخراً",

        // Day names
        sunday: "الأحد",
        monday: "الاثنين",
        tuesday: "الثلاثاء",
        wednesday: "الأربعاء",
        thursday: "الخميس",
        friday: "الجمعة",
        saturday: "السبت",

        // Time ranges
        morning: "صباحاً (6-12)",
        afternoon: "ظهراً (12-6)",
        evening: "مساءً (6-10)",
        night: "ليلاً (10-6)",

        // Yes/No/Maybe
        yes: "نعم",
        no: "لا",
        maybe: "ربما",

        // Smart insights empty state
        smartInsightsWillAppear: "ستظهر الرؤى الذكية عند وصول المزيد من الردود..."
    },

    // ==========================================
    // BULK SHARING WIZARD (Full UI)
    // ==========================================
    bulkWizard: {
        // Builder-mount success screen (first send from the Share step).
        remindersOnDashboard: "التذكيرات وحالة التسليم والمتابعات موجودة في لوحة التحكم.",
        goToDashboard: "افتح لوحة التحكم",
        outcomeScheduledTitle: "تمت جدولة الرسالة",
        outcomeScheduledBody: "ستُرسل رسالتك في {date}.",
        outcomeApprovalTitle: "بانتظار موافقة WhatsApp",
        outcomeApprovalBody: "يراجع WhatsApp كل رسالة جديدة قبل إرسالها، عادةً خلال دقائق قليلة. سيستلمها ضيوفك على WhatsApp فور الموافقة عليها، ولا داعي لفعل أي شيء آخر.",
        outcomeApprovalOthersSent: "يتم الآن إرسالها إلى الضيوف الذين يستلمونها عبر البريد الإلكتروني أو الرسائل النصية.",
        outcomeHeldTitle: "رسالتك الأولى قيد المراجعة",
        outcomeHeldBody: "هذه مراجعة لمرة واحدة عند الإرسال الأول. سنراسلك عبر البريد الإلكتروني فور الموافقة عليها. لم يُرسل أي شيء ولم تُستخدم أي أرصدة.",
        outcomeRefusedTitle: "لم يقبل WhatsApp هذه الرسالة",
        outcomeRefusedReason: "سبب WhatsApp: {reason}",
        outcomeRefusedOthersNow: "لا يزال يتم إرسالها إلى الضيوف الذين يستلمونها عبر البريد الإلكتروني أو الرسائل النصية.",
        outcomeRefusedOthersScheduled: "سيستلمها الضيوف عبر البريد الإلكتروني أو الرسائل النصية كما هو مقرر في {date}.",
        outcomeRefusedNoOthers: "لم تُرسل بعد إلى أي من ضيوفك.",
        outcomeRefusedFix: "للوصول إلى ضيوفك على WhatsApp، عدّل الرسالة من لوحة التحكم وأعد إرسالها. سيراجع WhatsApp النص الجديد.",
        tplErr_trailingParam: "لا يمكن أن تنتهي رسالتك بوسم تخصيص مثل {{name}} أو {{table_number}} لأن WhatsApp لا يسمح بذلك. أضف كلمة أو نقطة بعد الوسم وأعد الإرسال.",
        tplErr_waLink: "لا يسمح WhatsApp بزر يعيد إلى WhatsApp. اجعل الزر يشير إلى مكان آخر وأعد الإرسال.",
        tplErr_imageFormat: "يشترط WhatsApp أن تكون صورة دعوتك بصيغة JPG أو PNG. ارفعها مجددًا بهذه الصيغة وأعد الإرسال.",
        tplErr_imageProcess: "لم يتمكن WhatsApp من معالجة صورة دعوتك. جرّب صورة أخرى (JPG أو PNG، أقل من 5 ميغابايت) وأعد الإرسال.",
        tplErr_category: "يصنّف WhatsApp رسالتك كنوع مختلف عن النوع الذي سجلناها تحته. أعد إرسالها ويُفترض أن تُقبل.",
        tplErr_layout: "لم يتمكن WhatsApp من قراءة تنسيق رسالتك. غالبًا يكون السبب {{وسمًا}} وحده في سطر مستقل. ضعه داخل جملة وأعد الإرسال.",
        tplErr_duplicateName: "لدى WhatsApp رسالة محفوظة بهذا الاسم بالفعل. غيّر اسم الرسالة وأعد الإرسال.",
        tplErr_rateLimit: "بلغت حاليًا حد WhatsApp للرسائل الجديدة. انتظر قليلًا وأعد الإرسال، فلن يضيع شيء.",
        outcomeSubmitFailedTitle: "لم نتمكن بعد من إرسال رسالتك إلى WhatsApp للموافقة عليها",
        close: "إغلاق",
        outcomeSubmitFailedBody: "سنواصل المحاولة تلقائيًا وسنراسلك عبر البريد الإلكتروني إذا رفضها WhatsApp. لا داعي لفعل أي شيء الآن.",
        outcomeVerifyTitle: "أكّد بريدك الإلكتروني لإرسالها",
        outcomeVerifyBody: "تم حفظ رسالتك، لكن لم يُرسل أي شيء بعد. أكّد عنوان بريدك الإلكتروني (من تبويب المشاركة في نموذجك) وستُرسل تلقائيًا.",
        outcomeUpgradeTitle: "يلزم الترقية قبل الإرسال",
        outcomeUpgradeBody: "يستخدم هذا الحدث ميزات من قالبه تتطلب الترقية. قم بترقيته من لوحة التحكم الخاصة به وستُرسل رسالتك تلقائيًا. لم يُرسل أي شيء بعد.",
        outcomePausedTitle: "لم تُرسل رسالتك بعد",
        outcomePausedBody: "تم حفظها، لكن لم يُرسل أي شيء بعد. يمكنك متابعة حالتها من لوحة التحكم.",
        sendBlockedBlanks: "لا تزال رسالتك تحتوي على فراغات من القالب يجب ملؤها: {blanks}",
        sendDateMissing: "اختر تاريخًا لرسالتك المجدولة.",
        sendDatePast: "لقد مضى التاريخ والوقت المحددان. اختر وقتًا في المستقبل.",
        // Initial loading
        checkingAccess: "جاري التحقق من صلاحيات الوصول...",
        wizardFailedToLoad: "فشل تحميل معالج الرسائل. يرجى تحديث الصفحة.",

        // Progress steps
        step1Contacts: "1. جهات الاتصال",
        step2Channels: "2. القنوات",
        step2Review: "3. تخصيص",
        step3FollowUp: "4. متابعة",
        step4Send: "5. إرسال",

        // Navigation buttons
        previous: "السابق",
        next: "التالي",
        nextChannels: "التالي: قنوات الإرسال",
        nextCustomize: "التالي: تخصيص",
        nextFinalize: "التالي: إنهاء وإرسال",
        skip: "تخطي",
        saveAsDraft: "حفظ كمسودة",

        // Contacts step
        uploadContactList: "رفع قائمة جهات الاتصال",
        uploadContactsDesc: "ارفع جهات الاتصال بصيغة CSV أو vCard",
        dragDropFile: "اسحب وأفلت الملف هنا",
        orClickToBrowse: "أو انقر للتصفح",
        chooseFile: "اختر ملف",
        csvOrVcard: "CSV أو vCard (.vcf)",
        manuallyAddContacts: "إضافة جهات اتصال يدوياً",
        csvTemplate: "قالب CSV",
        vcardTemplate: "قالب vCard",

        // Phone tip
        phoneTip: "يجب أن تتضمن أرقام الهواتف رمز الدولة (مثال: +966501234567). إذا كنت تستخدم Excel، قم بتنسيق العمود كـ 'نص' لتجنب مشاكل التنسيق.",

        // Sending method
        sendVia: "إرسال عبر",
        channelEmail: "البريد الإلكتروني",
        channelEmailTooltip: "إرسال عبر البريد الإلكتروني. إذا لم يوجد بريد، سيتم استخدام الهاتف المحمول.",
        channelMobile: "الهاتف المحمول (واتساب/SMS)",
        channelMobileTooltip: "إرسال عبر واتساب، مع SMS كبديل. إذا لم يوجد هاتف، سيتم استخدام البريد الإلكتروني.",
        channelHint: "نقطة واحدة لكل قناة. النظام ينتقل لقنوات أخرى إذا فشل التسليم.",
        deliveryMethod: "طريقة التسليم",
        smartDeliveryLabel: "تسليم ذكي",
        smartDeliveryShortDesc: "واتساب/SMS عند توفره، وإلا البريد الإلكتروني.",
        smartDeliveryCreditNote: "نقطة واحدة لكل جهة اتصال.",
        customizeDelivery: "تخصيص",
        channelsStepTitle: "مراجعة قنوات الإرسال",
        channelsStepSubtitle: "اختر كيف سيتلقى ضيوفك هذه الدعوة.",
        usNumbersDeliveryNote: "🇺🇸 ملاحظة حول الأرقام الأمريكية: لا تدعم Meta إرسال رسائل WhatsApp الجماعية إلى الأرقام الأمريكية، لذا سيتم تحويلها تلقائيًا إلى رسائل SMS عادية. الأرقام الكندية تبدأ أيضًا بـ +1 لكنها غير متأثرة: تصلها الدعوة عبر WhatsApp. وإذا كان ضيوفك أصحاب الأرقام الأمريكية مسافرين خارج البلاد حاليًا، فننصح بشدة بإضافة عنوان بريد إلكتروني لهم لضمان وصول الدعوة.",
        deliveryModalTitle: "كيف نرسل الدعوات؟",
        deliveryOptionSmart: "تسليم ذكي",
        deliveryOptionSmartTag: "موصى به",
        deliveryOptionSmartDesc: "واتساب لجهات الاتصال خارج الولايات المتحدة، SMS لجهات الاتصال داخل الولايات المتحدة، والبريد الإلكتروني لجهات الاتصال بدون هاتف. نقطة واحدة لكل جهة اتصال.",
        deliveryOptionEmail: "البريد الإلكتروني أولاً",
        deliveryOptionEmailDesc: "يعطي الأولوية للإرسال عبر البريد الإلكتروني. يستخدم الهاتف المحمول تلقائيًا إذا لم يُقدَّم بريد إلكتروني.",
        deliveryOptionMobile: "الهاتف المحمول أولاً",
        deliveryOptionMobileDesc: "يعطي الأولوية للإرسال عبر الهاتف المحمول (واتساب/SMS). يستخدم البريد الإلكتروني تلقائيًا إذا لم يُقدَّم رقم هاتف.",
        deliveryOptionBoth: "كلا القناتين",
        deliveryOptionBothDesc: "الإرسال عبر البريد الإلكتروني والهاتف المحمول عند توفر كليهما.",
        deliveryOptionBothCost: "نقطة واحدة لكل جهة اتصال، حتى مع القناتين.",
        deliveryDoneBtn: "حفظ",
        deliveryCancelBtn: "إلغاء",
        usWhatsappShortNotice: "واتساب الجماعي غير مسموح به لأرقام الولايات المتحدة (سياسة Meta).",

        // SMS consent
        consentNotice: "قد تُطبَّق رسوم الرسائل والبيانات على ضيوفك (يختلف التكرار)، ويمكنهم الرد بـ STOP لإلغاء الاشتراك، HELP للمساعدة.",
        usWhatsappNotice: "وفقاً لسياسة Meta الحالية، لا يمكن لأرقام الهواتف الأمريكية استقبال رسائل WhatsApp الجماعية، وسيتم التحويل تلقائياً إلى SMS. لا يزال بإمكانك مراسلة الأرقام الأمريكية بشكل فردي عبر WhatsApp.",
        smsConsentCheckbox: "أؤكد أن جميع المستلمين وافقوا على تلقي رسائل SMS لدعوة الحدث عبر QuikRSVP.",
        smsConsentDisclosure: "يمكن للمستلمين الرد بـ STOP لإلغاء الاشتراك أو HELP للمساعدة. قد تُطبق رسوم الرسائل والبيانات. التكرار يختلف.",
        smsConsentRequired: "يجب تأكيد موافقة المستلمين قبل الإرسال.",
        termsConsentRequired: "يجب الموافقة على الشروط والأحكام وسياسة الخصوصية قبل الإرسال.",
        smsConsentEmailFallbackHint: "لا يوجد بريد إلكتروني لـ {n} من ضيوفك، لذا ستُرسل الرسالة إلى هواتفهم، وقد تصل كرسالة SMS.",
        smsConsentEditTitle: "تأكيد الموافقة على رسائل SMS",
        smsConsentEditBody: "بعض الضيوف في هذه الرسالة لديهم أرقام أمريكية أو أرقام أخرى ذات رمز الدولة 1 (مثل كندا) أو أرقام برازيلية، لذا قد تصلهم كرسالة SMS. أكّد موافقتهم لحفظ التغييرات.",
        smsConsentEditSave: "تأكيد وحفظ",
        termsLink: "الشروط والأحكام",
        privacyLink: "سياسة الخصوصية",

        // Contact summary
        valid: "صالح",
        invalid: "غير صالح",
        messages: "رسائل",
        editContacts: "تعديل جهات الاتصال",
        invalidContacts: "جهات اتصال غير صالحة:",

        // Follow-up banner
        followUpMessage: "رسالة متابعة",
        contactsAutoLoaded: "تم تحميل جهات الاتصال تلقائياً من رسالتك السابقة.",
        filterApplied: "تم تطبيق المرشح:",
        startFresh: "البدء من جديد",

        // File parsing
        dragDropCsv: "اسحب وأفلت ملف CSV هنا أو انقر للتصفح",
        dragDropVcard: "اسحب وأفلت ملف vCard هنا أو انقر للتصفح",
        csvColumns: "الأعمدة: أسماء الضيوف، اسم المجموعة، الهاتف، البريد الإلكتروني (اختياري: الحد الأقصى للضيوف، الوسوم)",
        downloadCsvTemplate: "تحميل قالب CSV",
        downloadVcardTemplate: "تحميل قالب vCard",
        vcardFromSources: "ملف .vcf قياسي من مصادر مثل جهات اتصال Google أو Outlook.",

        // Send step
        readyToSend: "جاهز للإرسال!",
        reviewAndSend: "راجع تفاصيل رسالتك وأرسل دعواتك.",
        messageSummary: "ملخص الرسالة",
        totalMessages: "إجمالي الرسائل",
        emailLabel: "البريد الإلكتروني",
        mobileLabel: "الهاتف المحمول",

        // Reminders
        remindersEnabled: "تذكيرات مفعلة:",

        // Credits
        messageCredits: "رصيد الرسائل",
        yourBalance: "رصيدك",
        creditsNeeded: "الرصيد المطلوب",
        readyToSendCredits: "جاهز للإرسال! لديك رصيد كافٍ لهذه الرسالة.",
        needMoreCredits: "تحتاج إلى المزيد من الرصيد.",
        purchasePackage: "اشترِ باقة للمتابعة.",

        // Send timing
        sendTiming: "توقيت الإرسال",
        sendImmediately: "إرسال فوراً",
        messagesQueuedNow: "سيتم وضع الرسائل في قائمة الانتظار فوراً",
        scheduleForLater: "جدولة لوقت لاحق",
        chooseDateTime: "اختر تاريخاً ووقتاً محدداً",
        date: "التاريخ",
        time: "الوقت",
        schedulingNote: "وقت التسليم تقريبي وغير مضمون. سيتم وضع الرسائل في قائمة الانتظار للمعالجة في الوقت المحدد.",

        // Buttons
        sendMessage: "مراسلة الضيوف",
        upgradeAndBuyCredits: "ترقية وشراء رصيد",
        buyCredits: "شراء رصيد",

        // Credits info
        creditsInfo: "تُحتسب النقاط لكل ضيف لا لكل رسالة • النقاط لا تنتهي صلاحيتها أبداً • تعمل على جميع النماذج",
        // Send step: guests per channel and the one cost line (_deliveryPlanHtml).
        deliveryPlanTitle: "كيف ستصل الرسالة إلى ضيوفك",
        deliveryWhatsapp: "واتساب",
        deliverySms: "رسالة نصية (SMS)",
        deliveryEmail: "البريد الإلكتروني",
        deliveryGuestsOne: "ضيف واحد",
        deliveryGuestsMany: "{n} من الضيوف",
        deliveryFullDesc: "رسالتك كاملة، مع أي صورة أو أزرار أضفتها",
        deliverySmsDesc: "نص فقط: بلا صورة ولا أزرار. تُرسل روابطك كعناوين ويب.",
        deliverySmsDescNoLink: "نص فقط: بلا صورة أو أزرار أو روابط.",
        deliverySmsWhy: "تصل إلى الأرقام الأمريكية رسالة نصية، لأن واتساب لا يوصل دعوات كهذه إلى الأرقام الأمريكية.",
        deliverySmsPreview: "عرض الرسالة النصية التي ستصلهم",
        deliverySmsCantSend: "لن تصل رسالة نصية إلى هؤلاء الضيوف: لا تحمل الرسالة النصية إلا الحروف اللاتينية، وهذه الرسالة لا تحتوي على أي منها. أضف نسخة إنجليزية من رسالتك في خطوة التخصيص لتصل إليهم.",
        deliverySmsEmailOnlyOne: "لدى واحد منهم عنوان بريد إلكتروني وستصله رسالة البريد الإلكتروني فقط.",
        deliverySmsEmailOnlyMany: "لدى {n} منهم عنوان بريد إلكتروني وستصلهم رسالة البريد الإلكتروني فقط.",
        deliverySmsNothingOne: "لن يصل أي شيء إلى ضيف واحد.",
        deliverySmsNothingMany: "لن يصل أي شيء إلى {n} من الضيوف.",
        costLabel: "التكلفة",
        costCreditsOne: "نقطة واحدة",
        costCreditsMany: "{n} نقطة",
        costPerGuest: "نقطة واحدة لكل ضيف",
        costPerGuestTicketed: "نقطة واحدة لكل ضيف تصله الرسالة على الهاتف؛ رسائل البريد الإلكتروني مجانية في الفعاليات ذات التذاكر",
        balanceAfterSending: "الرصيد بعد الإرسال: {n}",
        costUnsentNote: "تُعاد إليك بعد الإرسال النقاط المحجوزة للضيوف الذين لن يصلهم شيء.",
        remindersCostNote: "يكلّف كل تذكير نقطة واحدة لكل ضيف يصله، عند إرساله.",
        remindersCostNoteTicketed: "يكلّف كل تذكير نقطة واحدة لكل ضيف يصله على الهاتف، عند إرساله. رسائل البريد الإلكتروني مجانية.",
        notEnoughCreditsToSend: "الرصيد غير كافٍ: لديك {balance} نقطة وهذه الرسالة تحتاج إلى {needed}. اشترِ المزيد من النقاط ثم أعد الإرسال.",

        // Contact editor modal
        contactEditor: "محرر جهات الاتصال",
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        actions: "إجراءات",
        addNewContact: "إضافة جهة اتصال جديدة",
        saveContacts: "حفظ جهات الاتصال",
        cancel: "إلغاء",

        // Validation
        contactsCleared: "تم مسح جهات الاتصال. يمكنك الآن رفع قائمة جديدة.",

        // Review step labels
        composeYourMessage: "اكتب رسالتك",
        composeSubtitle: "خصّص دعوتك واختر كيف سيستلمها الضيوف.",
        messageAndTranslations: "الرسالة والترجمات",
        customEmailSettings: "إعدادات البريد الإلكتروني",
        buttonsLinks: "الأزرار والروابط",
        linksButtonsLabel: "روابط / أزرار",
        buttonsLinksHint: "اختر حتى زرين لإرفاقهما بالرسالة.",
        campaignButtonsMax: "يمكن تضمين زرين كحد أقصى في كل رسالة",
        buttonCaptionAlsoIn: "يُرسل أيضًا بـ{n}",
        buttonCaptionAsTyped: "صيغتك — تُرسل كما كتبتها تمامًا",
        buttonCaptionPairTip: "تظهر اللغتان معًا على الزر. وإذا تجاوز الاقتران 25 حرفًا وهو حد واتساب، يعود الزر إلى لغة واحدة — راجع المعاينة لترى النص الدقيق.",
        buttonLabelOptional: "نص الزر (اختياري)",
        buttonAppearsOn: "تظهر الأزرار في واتساب والبريد الإلكتروني.",
        rsvpTargetLabel: "إلى أين يوجّه رابط التأكيد؟",
        rsvpTargetForm: "نموذج QuikRSVP",
        rsvpTargetWebsite: "موقع زفافي",
        messageName: "اسم الرسالة",
        messageNamePlaceholder: "مثال: دعوات زفاف، تذكير عيد ميلاد...",
        messageNameHelp: "قم بتسمية هذه الرسالة للتعرف عليها لاحقًا",
        campaignNameDefaultDescriptor: "دعوات",
        campaignNameDupShort: "توجد بالفعل رسالة بهذا الاسم.",
        campaignNameDupViewExisting: "عرض الرسالة الحالية",
        emailSubjectLine: "عنوان البريد الإلكتروني",
        emailSenderName: "اسم المُرسل",
        emailSenderNameHelp: "الاسم الظاهر للضيوف",
        replyToLabel: "تصل الردود إلى",
        replyToDefaultSuffix: "افتراضي",
        replyToAddOption: "استخدام عنوان آخر…",
        replyToNewPlaceholder: "name@example.com",
        replyToSendVerify: "إرسال التأكيد",
        replyToSending: "جارٍ الإرسال…",
        replyToSent: "تم إرسال التأكيد. افتح ذلك البريد، واضغط على الرابط، ثم اختر العنوان هنا.",
        replyToRecheck: "لقد أكّدت",
        replyToAlreadyVerified: "هذا العنوان مؤكَّد بالفعل — اختره من القائمة.",
        replyToInvalid: "أدخل عنوان بريد إلكتروني صالحًا.",
        replyToError: "تعذّر إرسال التأكيد. حاول مرة أخرى.",
        replyToWhyVerify: "نؤكّد العنوان أولًا حتى لا تتمكّن الدعوات من توجيه الردود إلى بريد لا يملكه المُرسِل.",
        emailThemeColor: "لون البريد الإلكتروني",
        emailLogo: "شعار البريد",
        emailLogoUpload: "رفع",
        emailLogoHide: "إخفاء",
        emailLogoShow: "إظهار",
        emailLogoReset: "استخدام شعار QuikRSVP",
        emailLogoPaidOnly: "الخطط المدفوعة",
        emailLogoUpgradeMsg: "الشعار المخصص متاح في الخطط المدفوعة — قم بترقية النموذج لتخصيصه.",
        messageHeader: "عنوان الدعوة",
        messageHeaderHelp: "عنوان بخط عريض في أعلى بريدك الإلكتروني وواتساب. احذفه لإخفائه.",
        invitationTagline: "سطر الدعوة",
        invitationTaglineHelp: "نص أصغر أسفل العنوان (مثل \"أنت مدعو\"). احذفه لإخفائه. (البريد الإلكتروني فقط)",
        headerAndSubject: "العنوان والسطر والموضوع",
        leaveBlankToHide: "اتركه فارغًا لإخفائه",
        yourMessage: "رسالتك",
        writeMessagePlaceholder: "اكتب رسالة دعوتك هنا...",
        characters: "أحرف",
        translateTo: "ترجمة إلى:",
        translate: "ترجمة",
        translationWillAppear: "ستظهر الترجمة هنا...",
        // Message & Translations block (task #453)
        translateHint: "أرسل هذه الدعوة بلغة أخرى",
        translationsReady: "الترجمات جاهزة",
        messageLanguages: "لغات الرسالة",
        yourMessageBadge: "رسالتك",
        hide: "إخفاء",
        view: "عرض",
        addAnotherLanguage: "إضافة لغة أخرى",
        chooseLanguage: "اختر…",
        willSendAsWritten: "يستلم الضيوف {a} — الرسالة كما كتبتها تمامًا",
        willSendTranslationOnly: "يستلم الضيوف {a} فقط — لن تُرسل نسختك الأصلية",
        willSendBoth: "يستلم الضيوف {a} و{b} معًا في رسالة واحدة",
        oneTranslationOnly: "تحمل الرسالة نصك الأصلي وترجمة واحدة. ألغِ تحديد {lang} أولًا.",
        pickAtLeastOneLanguage: "اختر لغة واحدة على الأقل للإرسال.",
        addLanguageToTranslate: "اختر لغة للترجمة إليها.",
        emptyLanguageBlocked: "أضف نصًا لـ {langs}، أو ألغِ تحديد اللغة.",
        emptyLanguagesBlocked: "أضف نصًا لهذه اللغات أو ألغِ تحديدها: {langs}.",
        smsNotSendable: "لا يمكن إرساله كرسالة SMS",
        smsSourceOnly: "ترسل الـ SMS نصك الأصلي فقط",
        smsSendsTranslation: "ترسل الـ SMS ترجمتك بدلاً من ذلك",
        waCombinedOver: "تتشارك اللغتان رسالة واتساب واحدة — {n} من 1,024 حرفًا. اختصر إحداهما.",
        bothWillBeSent: "سيتم إرسال الأصل والترجمة",
        onlyTranslationWillBeSent: "سيتم إرسال الترجمة فقط",
        sendAsWrittenDesc: "الرسالة بالفعل بلغة الضيوف",
        sendTranslatedOnly: "إرسال النسخة المترجمة فقط",
        bilingual: "ثنائي اللغة",
        sendBilingual: "إرسال كلا (الأصل والترجمة) في رسالة واحدة",
        multiLanguageHint: "تحتاج للتواصل مع ضيوف بلغات مختلفة بشكل منفصل؟ أنشئ رسالة لكل لغة.",
        preview: "معاينة",
        addImage: "إضافة صورة",
        changeImage: "تغيير الصورة",
        convertingImage: "جارٍ تحويل صورة الآيفون…",
        processingImage: "جارٍ معالجة الصورة…",
        uploadingImage: "جارٍ الرفع…",
        invitationImage: "صورة الدعوة",
        invitationImageDesc: "اختياري — تظهر في أعلى البريد الإلكتروني ورسالة واتساب.",
        invitationSplashLabel: "فتح بملء الشاشة عند النقر",
        invitationSplashDesc: "الضيوف الذين ينقرون على الدعوة في واتساب يرونها بالحجم الكامل، ثم نموذج تأكيد الحضور.",
        beforeYouSend: "قبل الإرسال",
        goodToKnow: "ملاحظات حول الرصيد والتسليم",
        optionalLabel: "اختياري",
        csvFormattingTips: "نصائح تنسيق CSV",
        downloadTemplate: "تنزيل قالب",
        previewShowsExactly: "المعاينة تظهر بالضبط ما سيستلمه الضيوف.",

        // What happens next
        whatHappensNext: "ماذا يحدث بعد ذلك؟",

        // Success states
        campaignCreated: "تم إنشاء الرسالة!",
        messagesQueued: "رسائل في قائمة الانتظار",
        scheduledFor: "مجدول لـ",
        tip: "نصيحة",

        // Follow-up reminders step
        followUpRemindersTitle: "تذكيرات المتابعة",
        followUpRemindersDesc: "جدولة تذكيرات تلقائية لضيوفك",
        saveAndResubmitWhatsApp: "حفظ وإعادة الإرسال إلى واتساب",
        saveAndResend: "حفظ وإعادة الإرسال",
        saveAndResubmitHint: "يُرسل رسالتك المعدَّلة إلى واتساب للموافقة عليها مرة أخرى، ثم تصل إلى الضيوف الذين لم يستلموها.",
        saveAndResendHint: "يحفظ رسالتك المعدَّلة ويُرسلها إلى الضيوف الذين لم يستلموها.",
        // Edit & Resend feedback: the save is instant, the WhatsApp
        // re-submission is not, so they are reported separately (task #592).
        editSavedChanges: "تم حفظ التغييرات.",
        editSavedResubmitting: "تم حفظ التغييرات. جارٍ إرسال رسالتك إلى واتساب للموافقة…",
        translationStale: "تغيّرت رسالتك بعد ترجمتها. حدّث الترجمة.",
        translateAgain: "الترجمة من جديد",
        translationStaleBlocked: "غيّرت رسالتك بعد ترجمتها. حدّث الترجمة إلى {lang} قبل الإرسال: اضغط الترجمة من جديد، أو عدّلها بنفسك.",
        translationStaleWarn: "غيّرت رسالتك بعد ترجمتها. تأكّد من أن الترجمة إلى {lang} ما زالت مطابقة.",
        editSavedRescheduled: "تم حفظ التغييرات. ستُرسل رسالتك في {date}.",
        editTimingUseSend: "تم حفظ التغييرات. لا تزال رسالتك مجدولة في {date}. لإرسالها الآن، اضغط إرسال.",
        editSavedNotSent: "تم حفظ التغييرات. لم يُرسل أي شيء بعد. لإرسالها، افتح تعديل وإعادة الإرسال واضغط إرسال.",
        editSavedRescheduledPaused: "تم حفظ التغييرات. الموعد الجديد هو {date}. ستبقى الرسالة متوقفة مؤقتًا حتى تستأنفها.",
        editTimingAfterReminder: "هناك تذكير لهذه الرسالة مجدول في {date}. اختر موعدًا قبله، أو غيّر التذكير أولًا.",
        editTimingPast: "هذا الموعد قد مضى. اختر موعدًا في المستقبل.",
        editTimingPickDate: "اختر تاريخًا ووقتًا للإرسال المجدول.",
        editResubmitAccepted: "رسالتك المعدّلة لدى واتساب بانتظار الموافقة، وستُرسل فور الموافقة عليها.",
        editResubmitRefused: "واتساب لم يقبل الرسالة",
        sendTestSavedAsDraft: "تم حفظ رسالتك كمسودة لنتمكن من إرسال هذا الاختبار — ستجدها في قائمة رسائلك.",
        editBlockedSending: "لم تُحفظ تغييراتك: بدأ إرسال هذه الرسالة. بعد انتهاء الإرسال، أضف الضيوف الجدد عبر «إضافة جهات اتصال» في بطاقتها.",
        editBlockedStale: "لم تُحفظ تغييراتك: تغيّرت هذه الرسالة أثناء تعديلك لها (مثلًا أُضيف ضيوف أو تم إرسالها). أغلق هذه النافذة وافتحها مجددًا لتعديل أحدث نسخة.",
        nextFollowUp: "التالي: متابعة",
        addAnotherReminder: "إضافة تذكير",
        removeReminder: "إزالة",
        reminderNumber: "تذكير",
        whenToSend: "متى يتم الإرسال",
        sendTo: "إرسال إلى",
        reminderMessage: "الرسالة",
        reminderButtonsLabel: "الأزرار",
        reminderButtonRsvp: "رابط تأكيد الحضور",
        reminderRsvpAutoIncluded: "(يتم تضمين الرابط تلقائيًا)",
        reminderButtonRegistry: "قائمة الهدايا",
        reminderButtonDirections: "الاتجاهات",
        reminderButtonWebsite: "موقع الزفاف",
        reminderButtonsHint: "الأزرار اختيارية — أضِف حتى زرين، أو اترك الجميع فارغًا لإرسال تذكير نصي بسيط.",
        reminderButtonLabelLangHint: "إذا تُرك فارغًا، يظهر كل زر باللغتين كما هو موضح. النص الذي تكتبه يُرسل كما هو تمامًا — اكتب اللغتين إن أردت كلتيهما.",
        reminderEditButton: "تعديل",
        reminderEditTitle: "تعديل التذكير",
        reminderNewTitle: "تذكير جديد",
        reminderLinkedNote: "يُرسَل كتذكير مرتبط ضمن \"{name}\" — وليس رسالة جديدة.",
        reminderRecipientsFinalized: "يُحدَّد المستلمون عند إرسال التذكير.",
        reminderFixedRecipientsNote: "سيُرسل هذا التذكير إلى المستلمين الذين اخترتهم ({count}).",
        reminderSendNowHint: "الافتراضي هو الآن — سيُرسَل قريبًا (بمجرد موافقة واتساب على الرسالة). اختر تاريخًا ووقتًا لاحقين لجدولته.",
        reminderCancel: "إلغاء",
        reminderSaveChanges: "حفظ التغييرات",
        reminderCreateBtn: "إنشاء التذكير",
        reminderReviewContinue: "متابعة",
        reminderReviewPreviewNote: "من تزيله هنا يُستبعد من هذا التذكير فقط، ولا تتأثر تذكيراتك الأخرى. ويُحدَّد باقي القائمة عند إرسال التذكير — على سبيل المثال، يتم تخطي الضيوف الذين يردّون قبل ذلك تلقائيًا.",
        removeButton: "إزالة",
        linkChipUrlLabel: "الرابط",
        linkChipLabelLabel: "نص الزر",
        linkChipSave: "إضافة",
        linkChipUrlRequired: "أضف رابطًا، أو ألغِ.",
        remindAllTitle: "إرسال تذكير",
        remindAllSubtitle: "{n} مستلمين",
        remindAllPreConfigure: "لا يوجد ضيوف مطابقون الآن. سيُرسل هذا التذكير تلقائيًا إلى كل من ينطبق عليه عند الإرسال.",
        remindAllSendingTo: "جارٍ الإرسال إلى <strong>{n}</strong> ضيوف محددين.",
        remindAllAddedOptedOut: "التذكيرات متوقفة لـ {n} من الضيوف الذين أضفتهم، لذا لن يصلهم هذا التذكير.",
        remindAllContinue: "المتابعة للإرسال",
        remindAllNextStepHint: "ستختار طريقة الإرسال وتؤكد التكلفة في الخطوة التالية.",
        reminderUpdatedToast: "تم تحديث التذكير",
        reminderResubmittedToast: "تم تحديث التذكير وإعادة إرساله إلى واتساب للموافقة.",
        reminderCreatedToast: "تم إنشاء التذكير — سيُرسَل في الوقت المحدد.",
        reminderSendingNowToast: "تذكيركم في الطريق — يُرسَل الآن.",
        reminderUpdateFailed: "تعذّر تحديث التذكير: ",
        reminderCreateFailed: "تعذّر إنشاء التذكير: ",
        reminderAlertPickDateTime: "يرجى اختيار تاريخ ووقت الإرسال.",
        reminderAlertTrailingTag: "لا يمكن أن تنتهي رسالتك بوسم تخصيص مثل {{table_number}} — واتساب لا يسمح بذلك. أضف بضع كلمات بعده (مثل \"نراكم هناك!\").",
        reminderAlertValidDateTime: "يرجى إدخال تاريخ ووقت صالحين.",
        reminderAlertRegistryUrl: "أضِف رابطًا لقائمة الهدايا، أو ألغِ تحديدها.",
        reminderAlertDirectionsUrl: "أضِف رابطًا للاتجاهات، أو ألغِ تحديدها.",
        reminderAlertWebsiteUrl: "أضِف رابطًا لموقع الزفاف، أو ألغِ تحديده.",
        reminderAlertLivestreamUrl: "أضف رابطًا للبث المباشر، أو ألغِ التحديد.",
        reminderSendNowChoice: "إرسال الآن",
        reminderScheduleChoice: "جدولة لوقت لاحق",
        reminderGoesOutShortly: "سيتم إرسال التذكير قريبًا (بعد موافقة واتساب على الرسالة).",
        reminderHourOnlyHint: "تُرسَل التذكيرات عند رأس الساعة (لا تُستخدم الدقائق).",
        reminderIncludeImage: "تضمين صورة الدعوة",
        reminderImageHeading: "صورة",
        reminderTranslateLabel: "أرسِل أيضًا ترجمة إلى {lang}",
        reminderTranslateHint: "مُعطَّل افتراضيًا — يُرسَل تذكيرك تمامًا كما كُتب. فعِّله للترجمة والإضافة تلقائيًا.",
        useDifferentLink: "استخدام رابط آخر…",
        reminderIncludeThisImage: "تضمين هذه الصورة",
        reminderUseDifferentImage: "استخدام صورة مختلفة",
        reminderCustomImageNote: "يستخدم هذا التذكير صورة مختلفة عن صورة الدعوة.",
        reminderButtonsMax: "يمكنك تضمين زرين كحد أقصى لكل تذكير.",
        reminderButtonUrlPlaceholder: "الصق رابطًا (https://...)",
        invalidButtonUrlWarning: "هذا لا يبدو رابطًا صالحًا. إذا كان عنوانًا، الصق الرابط من خرائط Google — الروابط غير الصالحة تُحذف من رسائل WhatsApp.",
        reminderDirectionsUrlPlaceholder: "رابط خرائط Google أو Waze",
        reminderButtonUrlMissing: "أضف رابطًا للزر المحدد أو ألغِ تحديده.",
        resetToDefault: "إعادة تعيين إلى الافتراضي",
        guestsWhoHaventRSVPd: "الضيوف الذين لم يؤكدوا الحضور",
        attendingGuests: "الضيوف المؤكدون",
        allGuests: "جميع الضيوف",
        guestsAnsweredMaybe: "الضيوف الذين أجابوا «ربما»",
        guestsDeclined: "الضيوف الذين اعتذروا عن الحضور",
        twoWeeksBefore: "أسبوعين قبل الحدث",
        oneWeekBefore: "أسبوع قبل الحدث",
        threeDaysBefore: "3 أيام قبل الحدث",
        oneDayBefore: "يوم واحد قبل الحدث",
        dayOfEvent: "يوم الحدث",
        oneDayAfter: "اليوم التالي للحدث",
        threeDaysAfter: "بعد 3 أيام من الحدث",
        reminderButtonAlbum: "ألبوم صور الضيوف",
        reminderButtonLivestream: "البث المباشر",
        reminderLivestreamUrlPlaceholder: "رابط YouTube أو Zoom أو Facebook Live",
        reminderAlbumOff: "فعّل الألبوم من تبويب «صور الضيوف» للحصول على الرابط.",
        customDate: "تاريخ مخصص",
        pickReminderDate: "اختر تاريخًا",
        reminderTime: "الوقت",
        reminderTimeHint: "يُرسَل في هذا الوقت، حسب توقيتك المحلي.",
        guestNightWarning: "تنبيه: سيصل هذا إلى كثير من ضيوفك ليلًا (نحو {time} بتوقيتهم). سيُرسل في الوقت الذي اخترته، لكن الردود تصل عادةً أسرع في ساعات النهار.",
        reminderTimePast: "اختر تاريخًا ووقتًا في المستقبل للتذكير المخصص",
        reminderDateInvalid: "يجب أن يكون تاريخ التذكير في يوم الحدث أو قبله",
        reminderDateMissing: "يرجى اختيار تاريخ للتذكير المخصص",
        reminderNoEventDate: "لا يوجد تاريخ لمناسبتك بعد، لذا لا يمكن إرسال التذكير إلا في تاريخ تختاره. اختر \"تاريخ مخصص\"، أو أضف تاريخ المناسبة في المحرر لجدولة التذكيرات بناءً عليه.",
        reminderAfterRsvpDeadline: "يُغلق تأكيد الحضور قبل موعد هذا التذكير، لذلك لن يُرسَل. غيّر موعد تأكيد الحضور في المحرر، أو اختر وقتًا أبكر، أو أزل رابط تأكيد الحضور.",
        defaultReminderMessage: "مرحباً! مجرد تذكير ودي — نود أن نسمع منك! يرجى تأكيد حضورك عندما تستطيع.",
        defaultAttendingMessage: "نتطلع لرؤيتك! إليك تذكير سريع بتفاصيل الحدث.",
        defaultMaybeMessage: "مرحباً! أخبرتنا بأنك ربما تحضر — هل اتخذت قرارك؟ نود الحصول على إجابة نهائية، نعم أو لا، حتى نتمكن من التنظيم. يرجى تحديث تأكيد حضورك عندما تستطيع.",
        creditsChargedNote: "يتم خصم النقاط عند إرسال كل تذكير فعلياً. تأكد من وجود رصيد كافٍ في حسابك في ذلك الوقت.",
        skipFollowUpNote: "يمكنك تخطي هذه الخطوة وإرسال متابعات لاحقاً بإنشاء رسالة جديدة من لوحة التحكم.",
        remindersConfigured: "تذكير(ات) مجدولة",

        // Toast messages - Payment
        paymentSuccessClickMessage: "تم الدفع بنجاح! انقر على 'مراسلة الضيوف' للمتابعة.",
        paymentSuccessSendReady: "تم الدفع بنجاح! يمكنك الآن إرسال رسالتك.",
        paymentSuccessClickContinue: "تم الدفع بنجاح! يرجى النقر على 'مراسلة الضيوف' للمتابعة.",
        paymentSuccessGeneric: "تم الدفع بنجاح!",
        paymentProcessingWait: "يرجى الانتظار أثناء معالجة طلبك...",
        paymentSystemUnavailable: "نظام الدفع غير متاح. يرجى التحديث والمحاولة مرة أخرى.",
        paymentCompletedReady: "اكتمل الدفع بنجاح! رسالتك جاهزة للإرسال.",
        paymentSuccessEmoji: "🎉 تم الدفع بنجاح! يمكنك الآن إرسال رسالتك.",

        // Toast messages - Campaign
        cannotSaveDraftNoEvent: "لا يمكن حفظ المسودة: لم يتم اختيار حدث",
        pleaseLoginToSaveDrafts: "يرجى تسجيل الدخول لحفظ المسودات",
        failedToSaveDraft: "فشل حفظ المسودة. يرجى المحاولة مرة أخرى.",
        campaignSentSuccess: "🎉 تم إرسال الرسالة! تم استخدام {count} رصيد.",
        insufficientCredits: "رصيد غير كافٍ. يرجى شراء المزيد من الأرصدة لإرسال رسالتك.",
        errorProcessingCampaign: "خطأ في معالجة الرسالة. يرجى المحاولة مرة أخرى.",
        campaignSubmitted: "تم إرسال الرسالة! سيتم إرسال الرسائل تلقائياً.",
        campaignScheduledFor: "تم جدولة الرسالة! سيتم إرسال الرسائل في {date}.",
        failedToSchedule: "فشلت جدولة الرسالة. يرجى الاتصال بالدعم.",
        verifyEmailBeforeSending: "يرجى تأكيد بريدك الإلكتروني قبل الإرسال — أدخل الرمز في تبويب المشاركة في محرر النموذج ثم أرسل. رابطك يعمل للضيوف بالفعل. لم يتم إرسال أي شيء ولم يتم خصم أي رسوم.",

        // Toast messages - Translation
        translationComplete: "اكتملت الترجمة!",
        translationFailed: "فشلت الترجمة. يرجى المحاولة مرة أخرى.",
        translationFailedManual: "فشلت الترجمة. يرجى إدخال الترجمة يدوياً.",
        messageTranslatedTo: "تمت ترجمة الرسالة إلى {language}!",
        translationFailedRetry: "فشلت الترجمة. يرجى المحاولة مرة أخرى أو إدخال الرسالة يدوياً.",
        pleaseWriteMessageFirst: "يرجى كتابة رسالة أولاً",

        // Contact management
        loadFromContacts: "جهات الاتصال الخاصة بي",
        noSavedContacts: "لا توجد جهات اتصال محفوظة بعد. يتم حفظ جهات الاتصال التي تراسلها في أي حملة تلقائيًا في دفتر العناوين الخاص بك.",
        addressBook: "دفتر العناوين",
        addContact: "إضافة جهة اتصال",
        deleteContactConfirm: "هل تريد حذف جهة الاتصال هذه من دفتر العناوين الخاص بك؟",
        edit: "تعديل",
        delete: "حذف",
        save: "حفظ",
        contactNeedsInfo: "تحتاج جهة الاتصال إلى اسم وبريد إلكتروني أو هاتف.",
        importFromPhone: "استيراد من الهاتف",
        importFromPhoneCancelled: "لم يتم اختيار أي جهات اتصال.",
        importFromPhoneFailed: "فشل استيراد جهات الاتصال: ",
        importFromGoogle: "استيراد من جهات اتصال Google",
        noGoogleContactsFound: "لم يتم العثور على جهات اتصال في حسابك على Google.",
        googleContactsFailed: "فشل تحميل جهات اتصال Google: ",
        importFromResponses: "استخدام قائمة ضيوفي",
        importFromResponsesTitle: "الاستيراد من قائمة ضيوفك",
        importFromResponsesSubtitle: "كل من في قائمة ضيوف هذه المناسبة: من ردّوا ومن أضفتهم ولم يردّوا بعد. يمكن مراسلة من لديهم رقم هاتف أو بريد إلكتروني فقط.",
        noRespondersFound: "قائمة ضيوفك فارغة، لا أحد لاستيراده.",
        noReachableResponders: "لا أحد في قائمة ضيوفك لديه رقم هاتف أو بريد إلكتروني، لذا لا يوجد من يمكن مراسلته هنا.",
        respondersFailed: "تعذّر تحميل قائمة ضيوفك: ",
        respondersUnreachableNote: "{count} آخرون في قائمتك بلا رقم هاتف أو بريد إلكتروني، لذا لا يمكن مراسلتهم.",
        respondersAlreadyAdded: "موجود في قائمتك بالفعل",
        rsvpStatusColumn: "الرد",
        rsvpFilterAll: "الجميع",
        rsvpFilterYes: "سيحضرون",
        rsvpFilterMaybe: "ربما",
        rsvpFilterNo: "لن يحضروا",
        rsvpFilterWaitlisted: "قائمة الانتظار",
        rsvpFilterPending: "بانتظار الرد",
        rsvpStatusYes: "نعم",
        rsvpStatusMaybe: "ربما",
        rsvpStatusNo: "لا",
        rsvpStatusWaitlisted: "قائمة الانتظار",
        rsvpStatusPending: "بانتظار الرد",
        addMoreContacts: "إضافة جهات اتصال أخرى",
        exportCsv: "تصدير CSV",
        status: "الحالة",
        tags: "الوسوم",
        allTags: "كل الوسوم",
        replaceFile: "استبدال الملف",
        maxGuestsCol: "أقصى عدد ضيوف",
        maxGuestsColHint: "أقصى عدد من الضيوف يمكن لهذه الدعوة إحضارهم (اتركه فارغًا لاستخدام الحد الافتراضي للنموذج)",
        // The guest-list columns (task #935)
        guestNamesCol: "أسماء الضيوف",
        guestNamesColHint: "كيفية إضافة أسماء الضيوف\n• افصل بين الأسماء بفاصلة منقوطة (;). الفاصلة تعمل أيضًا.\n• أضف (طفل) بعد اسم الطفل، مثل: يوسف حداد (طفل).\n• مثال: سارة حداد; محمد حداد; يوسف حداد (طفل)\n• الهاتف والبريد في الصف للضيف الأول في القائمة.",
        guestNamesPh: "سارة حداد; مايكل حداد",
        groupNameCol: "اسم المجموعة",
        groupNameColHint: "لمن الدعوة موجّهة، مثل عائلة حداد. يظهر على الظرف وفي ترحيب النموذج؛ أما الرسائل فتحيّي أسماء الضيوف («مرحبًا سارة ومحمد»).\nاتركه فارغًا لضيف مدعو وحده. إذا ملأت اسم المجموعة فقط، يعثر الضيوف على دعوتهم به ويكتبون أسماءهم؛ ومع أسماء الضيوف، يعثر كل ضيف عليها باسمه.",
        groupNamePh: "عائلة حداد",
        contactPreviewTitle: "هكذا ستظهر هذه الدعوة",
        contactPreviewEnvelope: "موجهة إلى",
        contactPreviewGreetingLine: "مرحبًا {name}",
        contactPreviewLookup: "كتابة أي من هذه تعثر على الدعوة:",
        contactPreviewNoLookup: "أضف اسم عائلة أو اسم مجموعة ليتمكن هذا الضيف من العثور على الدعوة باسمه.",
        contactPreviewAsksNames: "لا أسماء بعد: من يعثر عليها سيُطلب منه إدخال أسماء أفراد مجموعته.",
        diffSurnamesTip: "نصيحة: أضف أرقام هواتف أو عناوين بريد إلكتروني أو أسماء كاملة لكل فرد في المجموعة، ليتمكن أي منهم من العثور على ردّه بسهولة.",
        sameNameWarning: "تنبيه: لديك عدة ضيوف أو مجموعات بالاسم نفسه. أضف بريدًا إلكترونيًا أو رقم هاتف لكل منهم ليتمكنوا من التحقق من هويتهم عند البحث عن الدعوة.",
        lastFirstFlag: "شخص واحد واسم العائلة أولًا؟ افصل بين الأشخاص المختلفين بـ «;».",
        prefillNameLabel: "تعبئة اسم كل ضيف في النموذج مسبقًا",
        prefillNameDesc: "يفتح كل رابط شخصي واسم جهة الاتصال مكتوب مسبقًا في خانة الاسم (وعلى المظروف إذا كان هذا الخيار مفعّلًا). أوقفه إذا كانت قائمتك تحتوي على ألقاب أو أرقام مشتركة — يكتب الضيوف أسماءهم بأنفسهم؛ وتبقى حدود عدد الضيوف سارية.",
        contactsSelected: "جهة/جهات اتصال مختارة",
        addSelected: "إضافة المختارة",
        selectAll: "تحديد الكل",
        importedContactsSummary: "تم استيراد {added} جهة اتصال. تم تخطي {skipped} كمكرر.",
        noOrgFound: "لم يتم العثور على مؤسسة. قم بإعداد مؤسستك في لوحة تحكم المؤسسة أولاً.",
        noOrgContacts: "لم يتم العثور على جهات اتصال في مؤسستك. أضف جهات اتصال في لوحة تحكم المؤسسة أولاً.",
        failedToLoadContacts: "فشل تحميل جهات الاتصال: ",
        selectAtLeastOneContact: "يرجى اختيار جهة اتصال واحدة على الأقل.",
        contactsClearedMessage: "تم مسح جهات الاتصال. يمكنك الآن تحميل قائمة جديدة.",
        unsavedContactsWarning: "لديك جهات اتصال غير محفوظة. اضغط إلغاء للعودة والحفظ، أو موافق لتجاهل التغييرات.",

        // File processing
        unsupportedFileType: "نوع ملف غير مدعوم. يرجى تحميل ملف CSV (.csv) أو vCard (.vcf).",
        fileAlreadyUploaded: "الملف \"{filename}\" تم تحميله بالفعل.",
        fileReplaced: "تم استبدال {replaced} جهة اتصال من \"{filename}\" بـ {count} من الملف الذي رفعته للتو.",
        fileMergedSummary: "تمت إضافة {added} جهة اتصال من \"{filename}\"؛ وتم تحديث {updated} موجودة أصلًا في قائمتك ببيانات الملف.",
        failedToProcessFile: "فشلت معالجة الملف. يرجى التحقق من التنسيق والمحاولة مرة أخرى.",
        noContactsInFile: "قرأنا الملف \"{filename}\" لكن لم نعثر فيه على أي جهات اتصال.\n\nالأعمدة الموجودة: {headers}\n\nكل جهة اتصال تحتاج إلى بريد إلكتروني أو رقم هاتف، تحت عنوان نتعرف عليه — مثل \"name\" أو \"email\" أو \"phone\". غيّر عناوين الأعمدة في ملفك وحاول الرفع مرة أخرى.",
        encodingDamageWarning: "يبدو أن الملف \"{filename}\" فقد الأحرف غير اللاتينية — تظهر الأسماء بصيغة \"???\" أو كرموز مشوّهة.\n\nيحدث هذا عادةً عندما يحفظ Excel على جهاز Mac ملف csv عادي. النص الأصلي لم يعد موجودًا في الملف، لذا سيؤدي الاستيراد إلى إنشاء جهات اتصال بأسماء غير مقروءة.\n\nللإصلاح: في Excel اختر ملف ← حفظ باسم ← \"CSV UTF-8 (مفصول بفواصل)\"، ثم ارفع الملف مرة أخرى. يصدّر Google Sheets وNumbers ملفات صحيحة تلقائيًا.\n\nهل تريد الاستيراد على أي حال؟",
        processingFile: "جارٍ معالجة {filename}...",
        missingNamesWarning: "{count} جهة/جهات اتصال بلا اسم — ستظهر باسم \"غير معروف\". أضف الأسماء في القائمة أدناه.",
        // Household invitations (task #908)
        householdCouplesSuggest: "{count} دعوة/دعوات تذكر أكثر من شخص، مثل «{example}». هل تريد احتساب كل من تذكرهم، مع تعبئة أسمائهم مسبقًا في النموذج؟",
        householdCouplesYes: "نعم، احتسبهم",
        householdNoThanks: "لا، شكرًا",
        householdFamiliesNote: "{count} دعوة/دعوات موجّهة إلى عائلة، مثل «{example}». أضف من سيحضر في {members} (أو حدّد {maxGuests}) ليملأ النموذج أسماءهم ويحسبهم بشكل صحيح.",

        // Payment verification modal
        loadingText: "جارٍ التحميل...",
        verifyingPayment: "جارٍ التحقق من حالة الدفع...",
        pleaseWaitVerify: "يرجى الانتظار أثناء تأكيد الترقية",
        paymentVerified: "تم التحقق من الدفع!",
        paymentProcessing: "الدفع قيد المعالجة",
        errorVerifyingPayment: "خطأ في التحقق من الدفع",

        // Contact editor
        validLabel: "صالح",
        checkLabel: "تحقّق",
        toCheck: "للتحقق",
        phoneCheckChargedNote: "سيُرسل ويُحتسب كما هو ما لم تصحّحه",
        phoneWarnDoubledCc: "رمز الدولة مكرر مرتين",
        phoneWarnCc927: "927 ليس رمز دولة — هل تقصد +972؟",
        phoneWarnNanpArea: "لا يمكن أن يبدأ رمز المنطقة في رقم +1 بـ 0 أو 1",
        phoneWarnNanpNoCc: "إذا كان هذا رقمًا أمريكيًا أو كنديًا فيجب أن يبدأ بـ +1: {suggest}",
        phoneWarnLength: "رقم الجوال +{cc} يحتوي على {want} أرقام بعد رمز الدولة، وهذا يحتوي على {got}",
        phoneWarnUkPrefix: "رقم الجوال +44 يبدأ بالرقم 7",
        phoneWarnIlPrefix: "رقم الجوال +972 يبدأ بالرقم 5",
        phoneWarnAssumed: "بدون رمز الدولة — تمت قراءته كرقم من {country} ({number})؛ غيّره إن كان ذلك خطأ",
        phoneWarnNeedsCountry: "بدون رمز الدولة — أضفه في البداية، مثلًا ‎+971",
        phoneWarnInvalid: "ليس رقمًا صالحًا ({country}) — تحقّق من الأرقام",
        phoneWarnInvalidAny: "ليس رقم هاتف صالحًا — تحقّق من الأرقام",
        phoneWarnLandline: "هذا خط أرضي ({country}) — لا يمكنه استقبال واتساب ولا الرسائل النصية",
        phoneCountryLabel: "الأرقام التي بلا رمز دولة تُقرأ كأرقام من",
        phoneCountryHint: "معظم الأرقام في قائمتك من {country}.",
        phoneCountryUse: "استخدام {country}",
        contactsLoaded: "تم تحميل جهات الاتصال",
        countryUnknown: "غير معروف",
        rowLabel: "الصف",
        deliveryDisclaimer: "لا يكون التسليم كاملًا بنسبة 100% أبدًا. قد يُحجب جزء صغير من الرسائل بسبب حدود التسويق لدى Meta أو مرشحات شركات الاتصالات أو مجلدات البريد العشوائي أو بيانات اتصال غير صحيحة — وهذا طبيعي في كل منصات المراسلة.",
        tagsCol: "الوسوم",
        tagsColHint: "المجموعة التي ينتمي إليها هذا الضيف، مثل العائلة أو الاستقبال فقط. افصل بين الوسوم بفواصل.\nإذا كان جزء من المناسبة مقتصرًا على وسوم معينة (يُضبط في المحرر ضمن أجزاء المناسبة)، فإن الرابط الشخصي لهذا الضيف يعرض فقط الأجزاء التي تطابق وسومه.",
        campaignNameDupAddInstead: "انقر هنا لإضافة جهات الاتصال مباشرةً إلى رسالتك الحالية",
        campaignNameDupAddInsteadSuffix: "بدلًا من ذلك",
        progressChecklistTitle: "تقدّمك",
        checkCampaignName: "اسم الرسالة",
        checkAddContacts: "إضافة جهات اتصال",
        checkCustomizeMessage: "تخصيص الرسالة",
        checkConfigureFollowUp: "إعداد المتابعة",
        checkSendInvitations: "إرسال الدعوات",
        contactsSummaryTitle: "ملخص جهات الاتصال",
        totalGuestsAdded: "إجمالي الضيوف المضافين",
        contactsImported: "جهات الاتصال المستوردة",
        needsAttention: "تحتاج إلى مراجعة",
        supportedImportMethods: "طرق الاستيراد",
        manualEntry: "إدخال يدوي",
        headerOptional: "(اختياري)",
        renameTooltip: "إعادة التسمية",
        gateNoRecipients: "أضف مستلمًا واحدًا على الأقل قبل الانتقال إلى الإرسال.",
        gateNoMessage: "اكتب رسالتك قبل الانتقال إلى الإرسال.",
        gateGoToStep: "الانتقال إلى الخطوة {n}",
        sendStalled: "انقطع الاتصال بخوادمنا قبل حفظ رسالتك — لم يُرسل شيء ولم يُستخدم أي رصيد. أعد تحميل الصفحة وافتح الرسالة مرة أخرى ثم اضغط إرسال من جديد.",
        loadingSites: "جارٍ تحميل مواقع زفافك…",
        noWeddingSites: "لم يُعثر على موقع زفاف.",
        createWeddingSite: "أنشئ موقعًا",
        usingSite: "المستخدم:",
        chooseSite: "اختر موقع زفاف…",
        siteNotPublished: "انشره لاستخدامه",
        noPublishedSite: "لم يُنشر أي من مواقع زفافك بعد — انشر موقعًا ليتمكن الضيوف من تأكيد الحضور.",
        rsvpEnabledHint: "تأكد من تفعيل صفحة تأكيد الحضور في موقعك ليتمكن الضيوف من الرد.",
        loadingFollowUp: "جارٍ تحميل رسالة المتابعة...",
        loadingDraft: "جارٍ تحميل المسودة...",
        creditsAlreadyEnough: "لديك رصيد كافٍ بالفعل لهذه الرسالة — راجعها واضغط إرسال.",
        remindersSkippedBeforeSend: "لم تتم جدولة {count} من التذكيرات — موعدها قبل إرسال هذه الرسالة.",
        followUpCampaign: "رسالة متابعة",
        campaignSummary: "ملخص الرسالة",
        sendCampaign: "مراسلة الضيوف",
        campaignName: "اسم الرسالة",
        campaignNamePlaceholder: "سمِّ رسالتك…",
        campaignNameHelp: "امنح هذه الرسالة اسمًا لتتعرّف عليها لاحقًا",
        campaignNameDuplicate: "توجد رسالة بهذا الاسم بالفعل. اختر اسمًا مختلفًا (مثلًا أضف «- المجموعة ب»)، أو أضف جهات الاتصال إلى رسالتك الحالية بدلًا من ذلك.",
        invalidLabel: "غير صالح",
        verifyCountryCode: "⚠ تحقق من رمز الدولة",
        enterGuestName: "أدخل اسم الضيف",
        emailPlaceholder: "name@example.com",
        phonePlaceholder: "+966501234567",
        validContacts: "جهات اتصال صالحة",

        // Scheduling
        scheduledTimePast: "لا يمكن الجدولة في وقت ماضٍ",
        recipientsLabel: "المستلمون",
        noNameLabel: "(بدون اسم)",
        removeRecipient: "إزالة",
        removeThisContact: "إزالة جهة الاتصال هذه",
        allRecipientsRemoved: "تمت إزالة جميع المستلمين. أضف بعضهم لتتمكن من الإرسال.",
        sendNoFormSelected: "لم يتم اختيار نموذج لهذه الرسالة. افتح نموذجاً محفوظاً أولاً، ثم حاول الإرسال مجدداً.",
        sendFormNotSaved: "لم يكتمل حفظ نموذجك بعد. أعد فتحه في المحرر واحفظه، ثم حاول الإرسال مجدداً.",
        draftSavedFindOnDashboard: "تم حفظ المسودة. ستجدها ضمن الرسائل في لوحة التحكم.",

        // Misc
        processingButton: "جارٍ المعالجة...",
        personalize: "تخصيص:",
        demoLabel: "تجريبي",
        searchContactsPlaceholder: "البحث بالاسم أو البريد الإلكتروني أو الهاتف...",
        loading: "جارٍ التحميل...",

        // New wizard keys
        fullNamePlus: "+ الاسم الكامل",
        firstNamePlus: "+ الاسم الأول",
        emailPlus: "+ البريد الإلكتروني",
        tableNumberPlus: "+ رقم الطاولة",
        tableTagDisabledHint: "قم بإعداد مخطط الجلوس المدمج للتخصيص باستخدام رقم طاولة كل ضيف.",
        tableExampleInput: "طاولتك هي {{table_number}}",
        tableSplitNoticeOne: "مجموعة واحدة تجلس على أكثر من طاولة دون أسماء جميع الضيوف، لذا سيظهر سطر الطاولة الخاص بها هكذا \"دانا 2، دانا 3\". أضف اسم كل ضيف في قائمة الضيوف ليكون واضحًا.",
        tableSplitNoticeMany: "عدد المجموعات التي تجلس على أكثر من طاولة دون أسماء جميع الضيوف: {count}. سيظهر سطر الطاولة الخاص بها هكذا \"دانا 2، دانا 3\". أضف اسم كل ضيف في قائمة الضيوف ليكون واضحًا.",
        clickToInsert: "انقر للإدراج — كل ضيف يتلقى نسخته المخصصة.",
        seeExample: "عرض مثال",
        hideExample: "إخفاء المثال",
        youWrite: "تكتب:",
        exampleInput: "مرحباً {{first_name}}، أنت مدعو لحدثنا!",
        eachGuestGets: "كل ضيف يتلقى:",
        sendTestEmailToMe: "أرسل لي بريدًا تجريبيًا أولاً",
        testEmailSending: "جارٍ إرسال البريد التجريبي…",
        testEmailSent: "تم إرسال بريد تجريبي إلى {email}",
        testEmailFailed: "تعذر إرسال البريد التجريبي",
        sendTestTitle: "أرسل اختباراً إلى نفسك",
        sendTestSubtitle: "احصل على نسخة حقيقية على هاتفك وبريدك، تماماً كما سيراها ضيوفك.",
        sendTestBtn: "إرسال اختبار",
        sendTestCostNote: "أول اختبار لهذه الرسالة مجاني. بعد ذلك يكلّف كل اختبار عبر SMS أو واتساب رصيداً واحداً — واختبارات البريد مجانية دائماً.",
        sendTestCostAfterFree: "تم استخدام الاختبار المجاني لهذه الرسالة. كل اختبار إضافي عبر SMS أو واتساب يكلّف رصيداً واحداً — واختبارات البريد تبقى مجانية.",
        sendTestPhoneLabel: "رقم الجوال للاختبار",
        sendTestPhoneHint: "لا يوجد رقم جوال في حسابك، لذا أدخل رقماً لإرسال الاختبار إليه. سنتذكّره.",
        sendTestPhoneInvalid: "لا يبدو هذا رقم جوال. استخدم الصيغة الدولية، مثل +14155550123.",
        sendTestSending: "جارٍ إرسال الاختبار…",
        sendTestDone: "تم إرسال الاختبار إليك",
        sendTestEmailCopyOnly: "البريد الإلكتروني نسخة لك فقط — لن يتلقى ضيوفك بريدًا إلكترونيًا.",
        sendTestFailed: "تعذّر إرسال الاختبار",
        sendTestCreditReturned: "أعدنا رصيد هذا الاختبار إلى حسابك.",
        sendTestEmptyMessage: "اكتب رسالتك أولاً — لا يوجد شيء لاختباره بعد.",
        sendTestRoutedToWhatsApp: "الرقم خارج الولايات المتحدة، لذا يستخدم هذا الاختبار واتساب.",
        // A test parked waiting for Meta, and every way that wait can end (task #604).
        sendTestQueued: "اختبارك في قائمة الانتظار. ما زال واتساب يراجع رسالتك — سيُرسل الاختبار تلقائيًا فور الموافقة، ولا يوجد ما تفعله هنا.",
        sendTestQueuedSent: "تمت الموافقة — أُرسل اختبارك للتو إلى واتساب الخاص بك.",
        sendTestQueuedFailed: "وافق واتساب على رسالتك، لكن تعذّر إرسال الاختبار. اضغط على إرسال اختبار للمحاولة مرة أخرى.",
        sendTestQueuedNoCredits: "وافق واتساب على رسالتك، لكن الاختبار المنتظر احتاج إلى رصيد ولم يكن متوفرًا. اشحن رصيدك ثم اضغط على إرسال اختبار مرة أخرى.",
        sendTestQueuedExpired: "انتهت صلاحية اختبارك المنتظر قبل أن يوافق واتساب على الرسالة. اضغط على إرسال اختبار مرة أخرى لإرسال واحد الآن.",
        // What the status webhook later says about an accepted WhatsApp test.
        sendTestDelivered: "تم التسليم إلى واتساب الخاص بك ✓",
        sendTestNotDelivered: "لم يتم تسليم اختبار واتساب",
        sendTestMetaLimit: "لم يسلّم واتساب هذا الاختبار: تحدّ Meta من عدد الرسائل التسويقية التي يمكن أن يستقبلها رقم هاتف واحد، وقد تؤدي الاختبارات المتكررة إلى بلوغ هذا الحد على رقمك أنت. حملتك وضيوفك لا يتأثرون بذلك إطلاقًا — يمكنك الإرسال بأمان. لإعادة الاختبار الآن، أرسل أي رسالة (ولو «مرحبًا» فقط) إلى رقم واتساب الذي وصلك منه الاختبار السابق، ثم أعد المحاولة — فهذا الحد لا يسري داخل محادثة مفتوحة. وإلا فانتظر بضع ساعات.",
        includeRsvpLink: "تضمين رابط تأكيد الحضور في الرسالة",
        rsvpLinkDisabledDesc: "عند التعطيل، يتم إرسال الرسالة بدون رابط نموذج تأكيد الحضور.",
        includeQrCode: "تضمين رمز QR لتسجيل الدخول",
        qrCodeDesc: "الضيوف الذين أكدوا حضورهم سيتلقون رمز QR شخصي.",
        qrCodeWhatsappNote: "في واتساب، سيحل رمز QR محل صورة الرسالة.",
        finalCampaignSummary: "ملخص الرسالة النهائي",
        messagesToSend: "رسائل للإرسال",
        creditsUsed: "أرصدة مستخدمة",
        clickingScheduleNote: "النقر على \"جدولة وإرسال\" سيضع رسائلك في قائمة الإرسال.",
        scheduleAndSend: "جدولة وإرسال",
        canStillGoBack: "لا يزال بإمكانك العودة وإجراء تغييرات قبل الإرسال.",
        campaignSentSuccessfully: "تم إرسال الرسالة بنجاح!",
        messagesBeingDelivered: "يتم الآن تسليم {count} رسالة.",
        windowWillClose: "ستُغلق هذه النافذة تلقائياً...",
        closeButton: "إغلاق",
        smsConsentAgree: "أوافق على",
        andText: "و",
        buyMessageCredits: "شراء أرصدة الرسائل",
        campaignRequires: "الرسالة تتطلب:",
        yourBalanceLabel: "رصيدك:",
        needLabel: "تحتاج:",
        selectPackage: "اختر حزمة:",
        bestValue: "أفضل قيمة",
        calcHelper: "كم رصيد أحتاج؟",
        freeShareBalance: "لديك {n} من رصيد الرسائل (كل حساب يبدأ بـ 25 مجانًا)، ورسالتك التجريبية الأولى مجانية أيضًا.",
        freeShareLead: "تفضّل إرسالها من هاتفك أو بريدك؟ بلا استخدام الرصيد:",
        freeShareCopy: "نسخ الرابط",
        freeSharePersonal: "روابط شخصية",
        freeShareCopied: "تم نسخ الرابط",
        calcGuests: "ضيوف",
        calcMsgs: "رسائل لكل واحد",
        calcCadence: "يرسل معظم المضيفين 3 رسائل لكل ضيف: الدعوة، تذكير، وتذكير يوم الحدث. عادةً ترسل التذكيرات فقط لمن لم يردوا، لذا الاستخدام الفعلي يكون أقل غالباً.",
        creditsAmount: "{count} نقطة",
        creditsMoreAmount: "{count} نقطة إضافية",
        creditsUnit: "نقطة",
        packEnoughForSend: "يكفي لهذه الرسالة",
        packNeedMore: "ينقصك {count}",
        creditsNeverExpireNote: "النقاط لا تنتهي صلاحيتها أبداً • استخدمها في جميع النماذج",
        haveEnoughCredits: "لديك رصيد كافٍ!",
        creditsAvailableNeeded: "{balance} نقطة متاحة (المطلوب {needed})",
        selectCreditPackage: "يرجى اختيار باقة نقاط",
        purchaseStartFailed: "تعذّر بدء عملية الشراء. يرجى المحاولة مرة أخرى.",
        previewNotInteractive: "معاينة — غير تفاعلية",
        emailTab: "بريد إلكتروني",
        whatsappTab: "واتساب",
        smsTab: "SMS",
        translating: "جارٍ الترجمة...",
        otherLanguage: "لغة أخرى",
        campaignSubmittedSuccessfully: "تم إرسال الرسالة بنجاح!",
        submittingCampaign: "جارٍ إرسال الرسالة...",
        submissionFailed: "فشل الإرسال",
        submitting: "جارٍ الإرسال...",
        errorDetails: "تفاصيل الخطأ:",
        missingEmailAndPhone: "البريد الإلكتروني والهاتف مفقودان",
        invalidEmailFormat: "تنسيق بريد إلكتروني غير صالح",
        invalidPhoneFormat: "تنسيق هاتف غير صالح",
        paymentSuccessful: "تم الدفع بنجاح!",
        unknownError: "خطأ غير معروف",
        removeImage: "إزالة الصورة",
        pendingTranslation: "بانتظار الترجمة",
        removeLanguage: "إزالة اللغة",
        notSpecified: "غير محدد",
    }
};

// Register with dashboard language system if available
if (window.DashboardLanguageSystem) {
    window.DashboardLanguageSystem.registerLanguageContent('ar', window.ArabicDashboardContent);
}
